import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

const AccountLinkCell = ({ dataKey, data, permissions }) => <React.Fragment>
  { data && data[dataKey] && AccessControl.hasPermission(permissions, [ActivityPerms.accountPageEdit, ActivityPerms.accountPageView])
  && <Link
    to={ `/account/${ data[dataKey] }` }
    id={ data[dataKey] }
  >
    { `${ data.accountNumber } - ${ data.accountName }` }
  </Link> }
  { data && data[dataKey] && !AccessControl.hasPermission(permissions, [ActivityPerms.accountPageEdit, ActivityPerms.accountPageView])
   && <span>
     { `${ data.accountNumber } - ${ data.accountName }` }
   </span> }
  { (!data || !data[dataKey]) && 'N/A' }
</React.Fragment>;

AccountLinkCell.propTypes = {
  dataKey: PropTypes.string,
  data: PropTypes.shape(),
  permissions: PropTypes.arrayOf(PropTypes.string)
};

AccountLinkCell.defaultProps = {
  dataKey: null,
  data: null,
  permissions: null
};

export default AccountLinkCell;
